import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import { Event } from "~/types/event";
import * as api from '~/utils/api';
export var name = 'eventTicket';
export var EventTicketStore = function EventTicketStore() {
  _classCallCheck(this, EventTicketStore);

  this.information = new Event();
  this.category = [];
  this.artists = [];
};
export var state = function state() {
  return new EventTicketStore();
};
export var getters = {
  information: function information(state) {
    return state.information;
  },
  category: function category(state) {
    return state.category;
  },
  artists: function artists(state) {
    return state.artists;
  }
};
export var mutations = {
  init: function init(state, _ref) {
    var eventData = _ref.eventData;
    state.information = Object.assign(state.information, eventData.information);
    state.category = Object.assign(state.category, eventData.category);
    state.artists = Object.assign(state.artists, eventData.artists);
  },
  editInformation: function editInformation(state, _ref2) {
    var information = _ref2.information;
    state.information = Object.assign(state.information, information);
  },
  editLocation: function editLocation(state, _ref3) {
    var location = _ref3.location;
    state.information.location = Object.assign(state.information.location, location);
  },
  editCategories: function editCategories(state, _ref4) {
    var ticketIndex = _ref4.ticketIndex,
        ticketCategory = _ref4.ticketCategory;
    state.category[ticketIndex] = ticketCategory;
  }
};
export var actions = {
  initializeStore: function initializeStore(context, eventData) {
    context.commit('init', {
      eventData: eventData
    });
  },
  updateInformation: function updateInformation(context, information) {
    context.commit('editInformation', {
      information: information
    });
  },
  updateLocation: function updateLocation(context, location) {
    context.commit('editLocation', {
      location: location
    });
  },
  updateTicketCategory: function updateTicketCategory(context, _ref5) {
    var number = _ref5.ticketIndex,
        ITicketCategory = _ref5.ticketCategory;
    context.commit('editCategories', {
      ticketIndex: number,
      ticketCategory: ITicketCategory
    });
  },
  save: function save(context) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var eventId, apiClient;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              eventId = context.state.information.entity_id;
              apiClient = api.ClientFactory.createApiClient();
              _context.next = 4;
              return apiClient.post("/api/users/".concat(context.rootState.auth.user, "/events/").concat(eventId), {
                event: context.state
              }).then(function (request) {
                if (request.data.success == true) {
                  return true;
                }
              }).catch(function (response) {
                return false;
              });

            case 4:
              return _context.abrupt("return", _context.sent);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};